export function CustomerStatementSettingsCtrl (
  $scope,
  inheritorApi
) {
  inheritorApi.inheritCtrl('CustomerStatementSettingsLiteCtrl', $scope);
}
